import "core-js/modules/web.dom.iterable";
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { queryAreaAlarm } from '@/api/api';
export default {
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    top: {
      type: String,
      default: '18px'
    },
    left: {
      type: String,
      default: '0'
    },
    queryType: {}
  },
  data: function data() {
    return {
      chart: 'chart45',
      angle: 0
    };
  },
  watch: {
    queryType: {
      handler: function handler(val) {
        this.getData(val);
      },
      immediate: true
    }
  },
  methods: {
    getData: function getData(queryType) {
      var _this = this;

      queryAreaAlarm({
        queryType: queryType
      }).then(function (res) {
        if (res.success) {
          var data = {
            xData: [],
            value: []
          };
          res.result.forEach(function (item) {
            data.xData.push(item.dateStr);
            data.value.push(item.evenNum);
          });

          _this.initBarChart(data);
        }
      });
    },
    initBarChart: function initBarChart(data) {
      // 初始化数据
      var option = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'transparent',
          axisPointer: {
            lineStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: 'rgba(126,199,255,0)' // 0% 处的颜色

                }, {
                  offset: 0.5,
                  color: 'rgba(126,199,255,1)' // 100% 处的颜色

                }, {
                  offset: 1,
                  color: 'rgba(126,199,255,0)' // 100% 处的颜色

                }],
                global: false // 缺省为 false

              }
            }
          },
          formatter: function formatter(p) {
            var dom = "<div style=\"width: 120px;\n\theight: 25px;;color:#fff;position: relative;\">\n        <div style=\"padding: 4px 8px 4px 14px;display: flex;\n        justify-content: center;\n        align-items: center;\n        flex-direction: column;position: relative;z-index: 1;\">\n            <div style=\"margin-bottom: 4px;width:100%;display:".concat(p[0] ? 'flex' : 'none', ";justify-content:space-between;align-items:center;\">\n                <span style=\"font-size:14px;color:#7ec7ff;padding-right: 5px\">").concat(p[0] ? p[0].seriesName : '', " : </span>\n                <span style=\"font-size:14px;color:#fff;\">").concat(p[0] ? p[0].data : '', " \u6B21</span>\n            </div>\n            <div style=\"width:100%;height:100%;display:").concat(p[1] ? 'flex' : 'none', ";justify-content:space-between;align-items:center;\">\n                <span style=\"font-size:14px;color:#7ec7ff;padding-right: 5px\">").concat(p[1] ? p[1].seriesName : '', " : </span>\n                <span style=\"font-size:14px;color:#fff;\">").concat(p[1] ? p[1].data : '', " \u6B21</span>\n            </div>\n        </div>\n    </div>");
            return dom;
          }
        },
        legend: {
          align: "left",
          right: '10%',
          top: '10%',
          type: 'plain',
          textStyle: {
            color: '#7ec7ff',
            fontSize: 16
          },
          // icon:'rect',
          itemGap: 25,
          itemWidth: 18,
          icon: 'path://M0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z',
          data: [{
            name: '上学'
          }, {
            name: '放学'
          }]
        },
        grid: {
          top: '25%',
          left: '15%',
          right: '10%',
          bottom: '20%' // containLabel: true

        },
        xAxis: [{
          type: 'category',
          boundaryGap: false,
          axisLine: {
            //坐标轴轴线相关设置。数学上的x轴
            show: true,
            lineStyle: {
              color: '#75bdeb'
            }
          },
          axisLabel: {
            //坐标轴刻度标签的相关设置
            textStyle: {
              color: '#7ec7ff',
              padding: 16,
              fontSize: 14
            },
            formatter: function formatter(data) {
              return data;
            }
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#192a44'
            }
          },
          axisTick: {
            show: false
          },
          data: data.xData
        }],
        yAxis: [{
          name: '次数',
          nameTextStyle: {
            color: "#7ec7ff",
            fontSize: 14,
            padding: 10
          },
          min: 0,
          splitLine: {
            show: false,
            lineStyle: {
              color: '#192a44'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#7ec7ff"
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#7ec7ff',
              padding: 16
            },
            formatter: function formatter(value) {
              if (value === 0) {
                return value;
              }

              return value;
            }
          },
          axisTick: {
            show: false
          }
        }],
        series: [{
          name: '抓拍次数',
          type: 'line',
          symbol: 'circle',
          // 默认是空心圆（中间是白色的），改成实心圆
          showAllSymbol: true,
          symbolSize: 0,
          smooth: true,
          lineStyle: {
            normal: {
              width: 5,
              color: "rgba(25,163,223,1)" // 线条颜色

            },
            borderColor: 'rgba(0,0,0,.4)'
          },
          itemStyle: {
            color: "rgba(25,163,223,1)",
            borderColor: "#646ace",
            borderWidth: 2
          },
          tooltip: {
            show: true
          },
          areaStyle: {
            //区域填充样式
            normal: {
              //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "rgba(25,163,223,.3)"
              }, {
                offset: 1,
                color: "rgba(25,163,223, 0)"
              }], false),
              shadowColor: 'rgba(25,163,223, 0.5)',
              //阴影颜色
              shadowBlur: 20 //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。

            }
          },
          data: data.value
        }]
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);
      window.addEventListener('resize', function () {
        myChart.resize();
      });
    }
  }
};